import { css } from '@emotion/react'
import { colors, InfoLabel, Text, VFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { formatCiapCid } from 'view/cuidados-compartilhados/util-cuidadoCompartilhado'
import { formatNomeProfissional } from 'view/profissional/utils/utils-profissional'

import { CuidadoCompartilhadoPlanoTableItemModel } from '../model-cuidadocompartilhado'

interface CuidadoCompartilhadoTablePanelProps {
  row: CuidadoCompartilhadoPlanoTableItemModel
}

export const CuidadoCompartilhadoTablePanel = (props: CuidadoCompartilhadoTablePanelProps) => {
  const {
    row: { ciap, cid10, discussao, lotacaoSolicitante, cidadaoAceitaAtendTic },
  } = props

  return (
    <VFlow vSpacing={0.5} style={styles.panel}>
      <InfoLabel title='Problemas/condições'>
        <Text>{formatCiapCid(ciap, cid10)}</Text>
      </InfoLabel>

      <InfoLabel title='Relato de caso'>
        <Text dangerouslySetInnerHTML={{ __html: discussao }} style={styles.discussao} />
      </InfoLabel>

      <InfoLabel title='Após devida explicação, o cidadão declara concordar de forma livre e esclarecida que o agendamento da consulta com o especialista poderá ser mediado por tecnologia?'>
        <Text>{cidadaoAceitaAtendTic ? 'Sim' : 'Não'}</Text>
      </InfoLabel>

      <HLabel title='Adicionado por:'>
        <Text>
          {formatNomeProfissional(lotacaoSolicitante.profissional)} - {lotacaoSolicitante.cbo.nome}
        </Text>
      </HLabel>
    </VFlow>
  )
}

const styles = {
  panel: css`
    padding: 1rem;
    background: ${colors.gray.c90};
  `,
  discussao: css`
    word-break: break-all;
  `,
}
